<template>
  <div class="wrapper">
    <div ref="text" class="text" :style="textStyle">
      <el-popover
        v-if="showMoreBtn"
        :content="content"
        trigger="click"
        placement="right"
      >
        <div style="width: 400px">{{ content }}</div>
        <span slot="reference" class="btn" @click="more">更多</span>
      </el-popover>
      <span :style="contentStyle">{{ content }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RowEllipsis',

  props: {
    content: {
      type: String,
      default: ''
    },

    rowNum: {
      type: Number,
      default: 2
    },

    contentStyle: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      showMoreBtn: false,
      textStyle: {
        lineHeight: 2.2,
        maxHeight: `${this.rowNum * 2.2}em`
      }
    }
  },

  mounted() {
    // 监听浏览器窗口的变化
    window.addEventListener('resize', this.showMore)
    // 通过hook监听组件销毁钩子函数
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.showMore)
    })
    this.showMore()
  },

  methods: {
    more() {
      this.$emit('more')
    },

    showMore() {
      this.$nextTick(() => {
        const textDOM = this.$refs.text
        this.showMoreBtn = textDOM?.scrollHeight > textDOM?.clientHeight
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  display: flex;
  overflow: hidden;
  /* margin: 50px auto; */
}
.text {
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: justify;
  line-height: 2.2;
  max-height: 4.4em;
  position: relative;
}
.text::before {
  content: '';
  height: calc(100% - 26px);
  float: right;
}
.btn {
  position: relative;
  float: right;
  clear: both;
  margin-left: 20px;
  font-size: 12px;
  cursor: pointer;
  border: 0;
  color: #1890ff;
}
.btn::before {
  content: '...';
  position: absolute;
  left: -5px;
  color: #333;
  transform: translateX(-100%);
}
</style>
